import { render, staticRenderFns } from "./ConfirmResetPassword.vue?vue&type=template&id=1b5a526e&"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmResetPassword.vue?vue&type=style&index=0&id=1b5a526e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports